import { render, staticRenderFns } from "./MarketAggregates.vue?vue&type=template&id=ae10751a&"
import script from "./MarketAggregates.vue?vue&type=script&lang=js&"
export * from "./MarketAggregates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports